import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

interface RentsOverview extends Vue {
    results: any[];
}

const RentsOverview = {
    template: "#rentOverview",
    name: "RentOverview",
    computed: {
        results(this: RentsOverview) { return this.$store.state.searchResults; },
    },
    mounted(this: RentsOverview) {
        // Loads all
        this.$store.commit("updateSearch", { action: "rent" });
    },
} as ComponentOptions<RentsOverview>;

export { RentsOverview };



// WEBPACK FOOTER //
// ./src/components/rents-overview.ts